import * as React from 'react'

import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import Checkbox from 'components/ui/checkbox'
import DiscoModal from 'components/ui/disco-modal'
import Heading from 'components/ui/heading'

type Props = {
  onSave: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
  saving: boolean
}
type State = {
  consent: boolean
}
export default class ContactsOptinModal extends React.Component<Props, State> {
  state: State = {
    consent: false,
  }
  _handleConsent: (label: any, value: boolean) => void = (
    label: any,
    value: boolean,
  ) => {
    this.setState({
      consent: value,
    })
  }

  render(): React.ReactNode {
    return (
      <DiscoModal onRequestClose={this.props.onCancel}>
        <div className="modal-width--400">
          <Heading size="600">Confirm opt-in</Heading>
          <div>
            <Checkbox
              label="The people I’m adding to my mailing lists have given me permission to email them."
              checked={this.state.consent}
              onChange={this._handleConsent}
            />
          </div>
          <div className="Form_ButtonsContainer separated-small">
            <ButtonContainer>
              <Button caption="Cancel" onClick={this.props.onCancel} />
              <Button
                appearance="primary"
                caption="Add to list"
                disabled={!this.state.consent}
                onClick={this.props.onSave}
                progressCaption="Adding to list"
                progressIndicator={this.props.saving}
              />
            </ButtonContainer>
          </div>
        </div>
      </DiscoModal>
    )
  }
}
